import http, { expandURI } from '@/utils/ajax'
import Vue from 'vue'
import clone from 'clone'
import { setDateTime } from '@/utils/date'
import Router from '@/router'
import {
  CLAIMS_CLAIMDETAIL_SAVE_LOADING,
  CLAIMS_CLAIMDETAIL_LOAD_DATA,
  CLAIMS_CLAIMDETAIL_SAVE_SUCCESS,
  CLAIMS_CLAIMDETAIL_SAVE_FAIL,
  CLAIMS_PARAMS_RESERVES_SUCCESS,
  CLAIMS_PARAMS_RESERVES_FAIL,
  CLAIMS_CLAIMDETAIL_CLAIMANT,
  CLAIMS_CLAIMDETAIL_CLAIMITEM,
  CLAIMS_PROCESS_NOTIF_SET,
  CLAIMS_CLAIMDETAIL_CLAIMHANDLERS,
  CLAIMS_HASRIORRESADJ
} from '@/store/types'
export const claim = {
  async createClaim({ commit, state }, formData) {
    // Only use this for Claim New - Claim and Save
    const apiUrl = state.claimRegister.menu.initSave
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        let lossDate = setDateTime(formData.lossDate, formData.lossTime)
        const formatData = {
          // follow NewClaimRegister (dto)
          // New Claim so revision is 0
          clmNo: formData.clmNo,
          clmNoAe: formData.clmNoAe,
          revision: 0,
          notDate: formData.notDate,
          lossDate: lossDate,
          lossTime: lossDate,
          polNo: formData.polNo,
          renCnt: formData.renCnt,
          endtCnt: formData.endtCnt,
          riskGrpNo: formData.riskGrpNo,
          riskNo: formData.riskNo,
          statDate: formData.statDate,
          clmStat: formData.clmStat,
          cseStat: formData.cseStat,
          vehRegNo: state.claimDetail.commonInfo.vehRegNo,
          vesNo: state.claimDetail.commonInfo.vesNo,
          vehVsl: state.claimDetail.commonInfo.vehVsl,
          tranDate: formData.tranDate
        }
        const result = await http.post(apiUrl, formatData)
        if (result.data) {
          const commitObject = {
            partialSave: false,
            data: result.data,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
          // Redict to specific Claim Header
          // if true = redirect - claimHeader
          // else claim process notif set
          let forward = false
          if (forward) {
            Router.push({ name: 'claimHeader' })
          } else {
            const { data } = result
            const record = {
              show: true,
              notifType: 'NEWCLM',
              clmNo: data.clmNo
            }
            commit(CLAIMS_PROCESS_NOTIF_SET, record)
          }
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to create Claim']))
        }
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async saveClaimHeader({ commit, state, getters }, claimHeader) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.saveClaimHeader
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, claimHeader)
        if (result.data) {
          const commitObject = {
            partialSave: true,
            data: result.data,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async saveClaimant({ commit, state, getters }, clmtData) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.saveClaimant
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmtData)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          commit(CLAIMS_CLAIMDETAIL_CLAIMANT, data)
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async removeClaimant({ commit, state, getters }, clmtData) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.removeClaimant
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmtData)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          commit(CLAIMS_CLAIMDETAIL_CLAIMANT, data)
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Claimant removed successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        }
        // else {
        commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        // }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async saveClaimItem({ commit, state, getters }, clmItem) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.saveClaimItem
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmItem)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          commit(CLAIMS_CLAIMDETAIL_CLAIMITEM, data)
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async removeClaimItem({ commit, state, getters }, clmItem) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.removeClaimItem
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmItem)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          commit(CLAIMS_CLAIMDETAIL_CLAIMITEM, data)
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Claim item removed successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        }
        // else {
        commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        // }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async saveClaimReserve({ commit, state, getters }, clmRes) {
    // Save Claim
    let promptAdj = false
    const apiUrl = state.claimRegister.menu.saveClaimReserve
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmRes)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          let obj = { hasRIOrResAdj: true }
          if (data.exceedLimit === true) {
            promptAdj = true
            obj = { hasRIOrResAdj: false }
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
          commit(CLAIMS_HASRIORRESADJ, obj)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
        return promptAdj
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async removeClaimReserve({ commit, state, getters }, clmRes) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.removeClaimReserve
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmRes)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Claim Reserve removed successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        }
        // else {
        commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        // }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async saveClaimServicer({ commit, state, getters }, clmServicer) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.saveClaimServicer
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmServicer)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async removeClaimServicer({ commit, state, getters }, clmSvc) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.removeClaimServicer
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const svcId = {
          clmNo: clmSvc.clmNo,
          clmtNo: clmSvc.clmtNo,
          clmItem: clmSvc.clmItem,
          inter: clmSvc.inter
        }
        const result = await http.post(apiUrl, svcId)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Claim Service Provider removed successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        }
        // else {
        commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        // }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async saveClaimStatus({ commit, state, getters }, clmStatus) {
    // Save Claim
    const apiUrl = state.claimRegister.menu.saveClaimStatus
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, clmStatus)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Claim status updated successfully.')
        return result.data.dataMap.message
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        }
        // else {
        commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        // }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async saveClaim({ commit, state, getters }) {
    // Save Claim
    const apiUrl = state.claimDetail.menu.save
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const submitForm = generateCurrentForm(state)
        const result = await http.post(apiUrl, submitForm)
        if (result.data) {
          const commitObject = {
            partialSave: true,
            data: result.data,
            query: false
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save Claim']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async claimReserves({ commit, state }, busCls) {
    const apiUrl = state.claimDetail.menu.reserves
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, busCls))
        const { data } = result.data
        if (result.data) {
          commit(CLAIMS_PARAMS_RESERVES_SUCCESS, data)
        }
      } catch (error) {
        commit(CLAIMS_PARAMS_RESERVES_FAIL, error)
      }
    }
  },
  async saveClaimPaymentHeader({ commit, state }, payment) {
    const apiUrl = state.claimDetail.menu.saveClaimPayment
    let promptAdj = false
    if (apiUrl) {
      commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, payment)
        if (result.data && result.data.dataMap) {
          const data = result.data.dataMap
          const commitObject = {
            partialSave: true,
            data: data.claimData,
            query: false
          }
          if (data.exceedValue === true) {
            promptAdj = true
          }
          commit(CLAIMS_CLAIMDETAIL_LOAD_DATA, commitObject)
        }
        commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
        Vue.prototype.$toast.success('Record saved successfully.')
        return promptAdj
      } catch (error) {
        if (error.response && error.response.data) {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['Fail to save your payment header']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      const err = { message: 'The request failed because it is trying to execute an invalid API url.' }
      throw err
    }
  },
  async printClaimFaceSheet({ commit, state }) {
    const apiUrl = state.claimDetail.menu.getMiscCLParam
    let msg = ''
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const { data } = result.data
        if (data) {
          let miscCLParam = data.miscCLParam
          let commonInfo = state.claimDetail.commonInfo
          if (miscCLParam.newClmPrtILN !== 'I' && commonInfo.clmStat !== 'C') {
            msg = "xMiscCLParam.NewClmPrtILN is not 'I', Face Sheet will not generate."
          } else if (miscCLParam.setClmPrtILN !== 'I' && commonInfo.clmStat === 'C') {
            msg = "xMiscCLParam.SetClmPrtILN is not 'I', Face Sheet will not generate."
          } else {
            const exportAPIUrl = state.claimDetail.menu.printClaimFaceSheet
            let clmFaceShtForm = {
              clmNo: commonInfo.clmNo,
              format: 'PDF',
              sendEmail: false
            }
            await http.post(exportAPIUrl, clmFaceShtForm)
          }
        }
      } catch (error) {}
      return msg
    }
  },
  async printClaimDocumentClaimEntry({ commit, state }) {
    const apiUrl = state.claimDetail.menu.printClaimDocumentClaimEntry
    if (apiUrl) {
      try {
        let commonInfo = state.claimDetail.commonInfo
        let clmHasRIOrResAdj = state.clmHasRIOrResAdj
        let expand = {
          clmNo: commonInfo.clmNo,
          branch: commonInfo.branch,
          dept: commonInfo.dept,
          hasRIorResAdj: clmHasRIOrResAdj.hasRIOrResAdj
        }
        http.get(expandURI(apiUrl, expand))
      } catch (error) {}
    }
  },
  async sendNotification({ commit, state, rootState }, clmPendExistList) {
    if (clmPendExistList.promptFlagRes) {
      const apiUrl = rootState.commons.menu.sendResNotification
      if (apiUrl) {
        try {
          await http.post(apiUrl, clmPendExistList.reverseOverLimitList)
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('Failed to send reverse notification:', err)
        }
      }
    }
    if (clmPendExistList.promptFlagPay) {
      const apiUrl = rootState.commons.menu.sendPaytNotification
      if (apiUrl) {
        try {
          await http.post(apiUrl, clmPendExistList.paymentOverLimitList)
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('Failed to send payment notification:', err)
        }
      }
    }
    commit('UPDATE_CLM_PEND_EXIST_LIST', {
      promptFlagRes: false,
      reverseOverLimitList: [],
      promptFlagPay: false,
      paymentOverLimitList: []
    })
  },
  async fetchClmHdlrs({ commit, state }) {
    commit(CLAIMS_CLAIMDETAIL_CLAIMHANDLERS, { loading: true, handlerList: [], userList: [] })
    const apiUrl = state.claimDetail.menu.clmHdlrs
    if (apiUrl) {
      const expand = {
        clmNo: state.claimDetail.commonInfo.clmNo
      }
      const result = await http.get(expandURI(apiUrl, expand))
      if (result && result.data) {
        const data = result.data
        // this.userList = data.data.userList
        // this.handlerList = data.data.clmHdlrs
        // commit(CLAIMS_CLAIMDETAIL_CLAIMHANDLERS, this.handlerList ? this.handlerList.length : 0)
        // let userMap = {}
        // let userList = data.data.userList
        let handlerList = data.data.clmHdlrs
        // if (userList && handlerList) {
        //   userList.forEach(function(user) {
        //     userMap[user.userId] = user
        //   })
        //   handlerList.forEach(function(handler) {
        //     handler.assignDate = new Date(handler.assignDate)
        //     if (handler.reviewDate) {
        //       handler.reviewDate = new Date(handler.reviewDate)
        //     }
        //     if (userMap[handler.userId]) {
        //       let user = userMap[handler.userId]
        //       handler.name = user.firstName + ' ' + user.lastName
        //       handler.usrRefId = user.usrRefId
        //     }
        //     if (handler.nxtRevUsrId) {
        //       if (userMap[handler.nxtRevUsrId]) {
        //         let user = userMap[handler.nxtRevUsrId]
        //         handler.nxtRevUserRefId = user.usrRefId
        //         handler.nxtRevUserDisp = handler.nxtRevUsrId + ' - ' + handler.nxtRevUserRefId
        //       }
        //     }
        //   })
        // }
        handlerList.forEach(function(handler) {
          handler.assignDate = new Date(handler.assignDate)
          if (handler.reviewDate) {
            handler.reviewDate = new Date(handler.reviewDate)
          }
          handler.name = handler.firstName + ' ' + handler.lastName
          if (handler.nxtRevUsrId) {
            handler.nxtRevUserDisp = handler.nxtRevUserRefId
          } else {
            handler.nxtRevUserDisp = ''
          }
        })
        const hdlrData = {
          // userList: userList,
          handlerList: handlerList,
          loading: false
        }
        commit(CLAIMS_CLAIMDETAIL_CLAIMHANDLERS, hdlrData)
      } else {
        const hdlrData = {
          userList: [],
          handlerList: [],
          loading: false
        }
        commit(CLAIMS_CLAIMDETAIL_CLAIMHANDLERS, hdlrData)
        this.$toast.error('Unexpected server response')
      }
    } else {
      this.$toast.error('Missing API URL (fetch claim handlers)')
    }
    this.loading = false
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = msgs => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = data => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}

function compileCommonForm(state) {
  // Compile it into a format that sync with the backend
  const cloneCommonForm = clone(state.claimDetail.commonInfo)
  let result = { ...cloneCommonForm }
  return result
}

export const generateCurrentForm = state => {
  let submitForm
  submitForm = generalClaimForm(state)
  return submitForm
}

export const generalClaimForm = state => {
  const result = Object.assign({}, compileCommonForm(state), clone(state.claimDetail.claimInfo))
  return result
}
